/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
'use client';

import { useState } from 'react';
import Image from 'next/image';
import { PlayCircleIcon } from '@heroicons/react/20/solid';
import { ModalVideoPlayer } from '@/components/ModalVideoPlayer';
import Button from '@/components/Button';
import { InternalEvent } from '../../events';
import clsx from 'clsx';

export function HeroAsset({ event, isPast }: { event: InternalEvent; isPast: boolean }) {
  const hasVideoAndIsPast = isPast && event.videoLink;
  const [isOpen, setOpen] = useState<boolean>(false);

  const openModal = () => {
    if (hasVideoAndIsPast) {
      setOpen(true);
    }
  };

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <div
      className={clsx('group relative aspect-[2/1] h-[200px] w-full md:h-auto', hasVideoAndIsPast && 'cursor-pointer')}
      onClick={openModal}
    >
      <ModalVideoPlayer isOpen={isOpen} videoLink={event.videoLink} onClose={closeModal} />

      <Image
        src={`/assets/images/events/event-heroes/${event.heroImageLink}`}
        alt="Event image"
        className={clsx('h-full w-full object-cover', hasVideoAndIsPast && 'opacity-55')}
        fill
      />

      {isPast && !event.videoLink && (
        <span className="text-caption absolute left-8 top-4 rounded-full bg-gradle-green px-4 py-2 text-white">
          Recording Coming Soon
        </span>
      )}

      {hasVideoAndIsPast && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
          <Button
            variant="ghost-light"
            className="group-hover:bg-gradient-to-br group-hover:from-gradle-blue group-hover:to-gradle-green"
          >
            <PlayCircleIcon className="size-10 cursor-pointer md:size-20" />
          </Button>
        </div>
      )}
    </div>
  );
}
